<template>
  <div class="page-container">
    <div class="header">
      <page-header @navBack="navBack" :back="true" :pageTitle="pageTitle">
      </page-header>
    </div>

    <div class="page-body">

      <div class="content">
        <div class="section-title">
            <span class="status"><span class="title-style">{{examTitles[testingIdx]?questionType[examTitles[testingIdx].questionType]:''}}</span></span>
            <span class="title-txt">{{examTitles[testingIdx]?examTitles[testingIdx].questionStem:'-'}}</span>
        </div>
        <div v-if="examTitles[testingIdx]&&examTitles[testingIdx].questionPic" class="section-img">
          <img :src="examTitles[testingIdx].questionPic" alt="img">
        </div>
        <div v-if="examTitles[testingIdx]" class="section-options">
          <div v-for="(item,index) in examTitles[testingIdx].answers" :key="index" @click="chooseAnswer(index)" :class="['option-item',{'active': item.select}]">
            <img v-if="!confirmFlag&&item.select&&item.ifCorrenct==0" class="icon-img" :src="require('../../assets/icon/icon-right'+(appno==1?'':appno)+'.png')" alt="icon">
            <img v-if="!confirmFlag&&item.select&&item.ifCorrenct==1" class="icon-img" src="@/assets/icon/icon-wrong.png" alt="icon">
            <span v-if="confirmFlag||!item.select" class="letter">{{index | getLetter}}</span>
            <span class="answer">{{item.answerText}}</span>
          </div>
        </div>
        <div class="section-bottom">

          <van-button
            v-if="confirmFlag"
            class="btn"
            type="primary"
            block
            @click="testing"
            >确认答案</van-button
          >

          <div v-if="!confirmFlag" class="explaintion">
            <div class="your-answer">答案{{rightAndYour[testingIdx]?rightAndYour[testingIdx].r:''}} &nbsp;&nbsp; 您选择{{rightAndYour[testingIdx]?rightAndYour[testingIdx].u:''}}</div>
            <div class="wrap">
              <div class="title s-16 line">官方解释</div>
              <p class="desc">{{examTitles[testingIdx].questionAnalyse||'暂无'}}</p>
            </div>
          </div>
        </div>

        <div v-if="!confirmFlag" class="btn-wrap">
          <van-button @click="prev" class="btn default" type="primary">上一题</van-button>
          <van-button @click="next" class="btn" type="primary">{{(testingIdx >= examTitles.length-1)?'完成':'下一题'}}</van-button>
        </div>

        <div @click="showPopup" class="section-desc">
          <div class="left">
            <!-- <img src="@/assets/icon/icon-page.png" alt="icon">
            <span>交卷</span> -->
          </div>
          <div class="right-wrap">
            <div class="right right-answer">
              <img :src="require('../../assets/icon/icon-right'+(appno==1?'':appno)+'.png')" alt="icon">
              <span>{{rightCount}}</span>
            </div>
            <div class="right wrong-answer">
              <img src="@/assets/icon/icon-wrong.png" alt="icon">
              <span>{{wrongCount}}</span>
            </div>
            <div class="right">
              <!-- <img src="@/assets/icon/icon-wrong.png" alt="icon"> -->
              <van-icon style="margin-right:6px" name="apps-o" size="20" />
              <span>{{testingIdx+1}}/{{examTitles.length}}</span>
            </div>

          </div>
        </div>
      </div>

    </div>

    <van-popup
      v-model="titlePopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="popup-wrap">
        <div class="section-desc">
          <div class="left">
            <!-- <img src="@/assets/icon/icon-page.png" alt="icon">
            <span>交卷</span> -->
          </div>
          <div class="right-wrap">
            <div class="right right-answer" v-show="testStat">
              <img :src="require('../../assets/icon/icon-right'+(appno==1?'':appno)+'.png')" alt="icon">
              <span>{{rightCount}}</span>
            </div>
            <div class="right wrong-answer" v-show="testStat">
              <img src="@/assets/icon/icon-wrong.png" alt="icon">
              <span>{{wrongCount}}</span>
            </div>
            <div class="right">
              <!-- <img src="@/assets/icon/icon-wrong.png" alt="icon"> -->
              <van-icon style="margin-right:6px" name="apps-o" size="20" />
              <span>{{testingIdx+1}}/{{examTitles.length}}</span>
            </div>
          </div>
        </div>
        <div class="section-cicle">
          <span v-for="(item,index) in examTitles" :key="index" :class="['cicle-index', {active:index==testingIdx}]">{{index+1}}</span>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import PageHeader from "../../components/page-header.vue";
import { getExamTitle } from '../../api/user';
export default {
  data() {
    return {
	  testStat: true,
      pageTitle: "随堂练习",
      titlePopup: false,
      confirmFlag: true,
      testingIdx: 0,
      practiceId: '',
      subject: 1,
      // rightCount: 0,
      // wrongCount: 0,
      examTitles: [],
      answers: [],
      rightAndYour: [],
      yourAnswer: '',
      questionType: {
        1: "单选题",
        2: "多选题",
        3: "判断题",
      },
    };
  },
  computed: {
    appno() {
      return this.$store.state.app.appno
    },
    courseid() {
      return this.$store.state.user.courseid
    },
    rightCount() {
      let arr = this.rightAndYour.filter(v => v.check);
      return arr.length;
    },
    wrongCount() {
      let arr = this.rightAndYour.filter(v => !v.check);
      return arr.length;
    },
    rightAnswer() {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let ans = '';
      this.answers.map((v,i) => {
        if(v.ifCorrenct==0) {
          ans += letters.charAt(i);
        }
      })
      return ans;
    },
    // yourAnswer() {
    //   const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    //   let ans = '';
    //   this.answers.map((v,i) => {
    //     if(v.select) {
    //       ans += letters.charAt(i);
    //     }
    //   })
    //   return ans;
    // }
  },
  components: {
    PageHeader,
  },
  mounted() {
    this.practiceId = this.$route.query.id;
    this.subject = this.$route.query.subject;
    this.getExamTitle();
	if (location.host.startsWith('shuangpu.')) {
	  this.testStat = false;
	}
  },
  destroyed() {
    // sessionStorage.removeItem('wrongArr')
  },
  methods: {
    getExamTitle() {
      getExamTitle(this.practiceId).then(res => {
        // 过滤正确的题目
        let wrongArr = sessionStorage.getItem('wrongArr');
        if (wrongArr) {
          wrongArr = JSON.parse(wrongArr);
        } else {
          wrongArr = [];
        }
        let titles = res;
        if(wrongArr&&wrongArr.length) {
          this.examTitles = titles.filter((item,i) => {
            return wrongArr.indexOf(i) != -1;
          })
        } else {
          this.examTitles = titles;
        }

      }).catch(() => {

      })
    },
    chooseAnswer(index) { // 选择答案
      let answers = this.examTitles[this.testingIdx].answers;
      let type = this.examTitles[this.testingIdx].questionType;
      answers.map((v,i) => {
        let flag = !!v.select;
        if (type == 2) { // 多选
          if (i == index) v.select = !flag;
        } else { // 单选 判断
          if (i == index) {
            v.select = !flag;
          } else {
            v.select = false;
          }
        }
      })
      this.examTitles[this.testingIdx].answers = answers;
      this.answers = answers;
      this.$set(this.examTitles, this.testingIdx, this.examTitles[this.testingIdx]);
      this.getYourAnswer();
    },
    testing() {
      const answer = this.answers.find(v => v.select)
      if(answer) {
        this.confirmFlag = false;
        // if (this.rightAnswer==this.yourAnswer) {
        //   this.rightCount++;
        // } else {
        //   this.wrongCount++;
        // }
        this.rightAndYour.push({
          r: this.rightAnswer,
          u: this.yourAnswer,
          check: this.rightAnswer==this.yourAnswer
        })
      } else {
        this.$dialog.alert({
          message: '请选择至少一个答案',
          theme: 'round-button',
          confirmButtonColor: '#fca142',
          width: 290,
        });
      }
    },
    getYourAnswer() {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let ans = '';
      this.answers.map((v,i) => {
        if(v.select) {
          ans += letters.charAt(i);
        }
      })
      this.yourAnswer = ans;
    },
    prev() {
      if(this.testingIdx <= 0) {
        this.$dialog.alert({
          message: '已经是第一题了',
          theme: 'round-button',
          confirmButtonColor: '#fca142',
          width: 290,
        });
        return;
      }
      this.testingIdx--;
    },
    next() {
      if(this.testingIdx >= this.examTitles.length-1) {
        // this.$dialog.alert({
        //   message: '已经是最后一题了',
        //   theme: 'round-button',
        //   confirmButtonColor: '#fca142',
        //   width: 290,
        // });
        let ws = [];
        let wrongArr = sessionStorage.getItem('wrongArr');
        if (wrongArr) {
          wrongArr = JSON.parse(wrongArr);
        } else {
          wrongArr = [];
        }
        this.rightAndYour.map((v,i) => {
          if(!v.check) {
            if(wrongArr&&wrongArr.length) {
              ws.push(wrongArr[i])
            }else{
              ws.push(i)
            }
          }
        });
        sessionStorage.setItem('wrongArr', JSON.stringify(ws));
        this.$router.push({ path: '/result', query: { all: this.examTitles.length, r: this.rightCount, w: this.wrongCount, subject: this.subject, id: this.practiceId } })
        return;
      }
      this.testingIdx++;
      let answers = this.examTitles[this.testingIdx].answers;
      this.answers = [...answers];
      if(this.rightAndYour.length-1<this.testingIdx) this.confirmFlag = true;
    },
    showPopup() {
      this.titlePopup = true;
    },
    navToScoreList() {
      this.$router.push({ path: '/score' })
    },
    navBack() {
      this.$router.push({ path: '/video', query: { courseid: this.courseid, subject: this.subject } })
    }
  },
};
</script>

<style lang="less" scoped>

.header {
  position: absolute;
  width: 100%;
  height: 200px;
  padding-bottom: 14px;
  border-bottom-left-radius: 26px 10px;
  border-bottom-right-radius: 26px 10px;
}

.tips {
  padding: 4px 12px;
  font-size: 12px;
}

.page-container {
  min-height: 100vh;
}
.page-body {
  height: 100%;
  margin-top: 0;
  padding: 80px 0 15px;
  .content {
    position: relative;
    top: -14px;
    background: #fff;
    border-radius: 14px;
    padding: 20px 15px 35px;

    .section-title {
      display: flex;
      margin-bottom: 12px;
      .status {
        flex-shrink: 0;
        margin-right: 6px;
      }
      .title-style {
        display: inline-block;
        margin-top: 2px;
        padding: 2px 6px;
        background: linear-gradient(90deg, #FCB535, #FF8506);
        border-radius: 17px;
        color: #FBF9F8;
        font-size: 11px;
      }
      .title-txt {
        font-size: 15px;
        color: #444444;
        line-height: 1.8;
      }
    }
    .section-img {
      margin-bottom: 10px;
      img {
        width: 100%;
      }
    }
    .section-options {
      margin-bottom: 40px;
      .option-item {
        margin-bottom: 12px;
        color: #444444;
        .letter {
          display: inline-block;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 13px;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
          margin-right: 8px;
          border-radius: 20px;
        }
        .icon-img {
          display: inline-block;
          width: 20px;
          margin-right: 8px;
          border-radius: 20px;
          box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
          vertical-align: top;
        }
        &.active {
          .letter {
            color: #fff;
            background: #FCA142;
          }
        }
      }
    }
    .btn-wrap {
      display: flex;
      justify-content: flex-end;
      margin: 40px 0 0;
      .btn {
        width: 70px;
        padding: 0;
        height: 30px;
        font-size: 14px;
        margin: 0 10px 0 0;
      }
    }
    .section-bottom {
      margin: 0 -15px;
      .explaintion {
        .wrap {
          padding: 0 15px;
        }
        .your-answer {
          height: 40px;
          line-height: 40px;
          color: #666;
          background: #F0EEEE;
          padding: 0 15px;
          margin-bottom: 20px;
        }
        .desc {
          color: #444444;
          line-height: 1.8;
        }
      }
    }
    .section-desc {
      display: flex;
      justify-content: space-between;
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 60px;
      left: 0;
      padding: 0 20px;
      line-height: 60px;
      border-top: 1px solid #E1E1E1;
      background: #ffffff;
      z-index: 10;
      img {
        width: 20px;
        margin-right: 8px;
      }
      .left {
        display: flex;
        align-items: center;
      }
      .right-wrap {
        display: flex;
      }
      .right {
        display: flex;
        align-items: center;
        margin-right: 12px;
        &.right-answer {
          color: #FF8506;
        }
        &.wrong-answer {
          color: #FF1A1A;
        }
      }
    }
  }

}

.popup-wrap {
  .section-desc {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 60px;
      left: 0;
      padding: 0 20px;
      line-height: 60px;
      border-top: 1px solid #E1E1E1;
      background: #ffffff;
      z-index: 10;
      img {
        width: 20px;
        margin-right: 8px;
      }
      .left {
        display: flex;
        align-items: center;
      }
      .right-wrap {
        display: flex;
      }
      .right {
        display: flex;
        align-items: center;
        margin-right: 12px;
        &.right-answer {
          color: #FF8506;
        }
        &.wrong-answer {
          color: #FF1A1A;
        }
      }
    }
    .section-cicle {
      padding: 0 20px;
      .cicle-index {
        display: inline-block;
        width: 40px;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #AAAAAA;
        border-radius: 50%;
        margin-right: 8px;
        margin-bottom: 8px;
        text-align: center;
        line-height: 40px;
        color: #666;
        &.active {
          background: #FF8506;
          color: #ffffff;
          border-color: transparent;
        }
      }
    }
}

.popup-content {
  width: 290px;
  // border-radius: 12px;
  overflow: hidden;
  background: #fff;
  &>.title {
    background: linear-gradient(90deg, #FCA142, #FF8506);
    padding: 15px;
    font-size: 18px;
    color: #fff;
    text-align: center;
  }
  .content {
    margin: 20px 0 10px;
    padding: 0 10px;
    font-size: 12px;
    .list {
      display: flex;
      align-items: center;
      margin-top: 10px;
      span {
        display: inline-block;
        width: 50%;
      }
    }
  }
  .btn-wrap {
    display: flex;
    padding: 15px;
    .btn {
      width: 40%;
      font-weight: 500;
    }
  }
}

.APP02 {
  @colorMain: #2db1ac;
  @colorSecond: #48d8a0;
  .page-body {
    .content {
      .section-title {
        display: flex;
        margin-bottom: 12px;
        .title-style {
          background: linear-gradient(90deg, @colorSecond, @colorMain);
        }
      }
      .section-options {
        .option-item {
          &.active {
            .letter {
              background: @colorSecond;
            }
          }
        }
      }
    }

  }
}
.APP03 {
  @colorMain: #1175fe;
  @colorSecond: #3fadfa;
  .page-body {
    .content {
      .section-title {
        display: flex;
        margin-bottom: 12px;
        .title-style {
          background: linear-gradient(90deg, @colorSecond, @colorMain);
        }
      }
      .section-options {
        .option-item {
          &.active {
            .letter {
              background: @colorSecond;
            }
          }
        }
      }
    }

  }
}
</style>
